import React, { useState, useEffect,useContext } from 'react'


import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'

import { useNavigate } from 'react-router-dom'
import DynamicIcon from '../../components/dynamicicon'
import JisButton from '../../components/controls/jisButton';
import JisPrompt from '../../components/jisprompt';



function Templates() {
 const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [openSuccess, setOpenSuccess] = useState(false)
    const {temptype} = useParams();
    const [deleteBox, setDeleteBox] = useState(false)
    const tempUrl= `${Constants.apiUrl}/setup/templates/${temptype}`;
    const [templates, setTemplates]=useState([]);

    const [filterTemps, setFilterTemps]=useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [index, setIndex] =useState(-1);
    const [search, setSearch] = useState('');
    const [deleteobj, setDeleteObj] = useState ({});
  



    const navigate = useNavigate();
    

      useEffect(() => {     
            LoadTemplates();
      }, [temptype])


    const LoadTemplates=()=>{
         setIsLoading(true);
         fetch(tempUrl, {
             method: 'GET',
             headers: {
               'Content-type': 'application/json',
               Authorization: `Bearer ${token}`,
             },
           })
             .then((resp) => resp.json())
             .then((data) => {
                 setIsLoading(false);
                 if(data.code==0){
                     setTemplates(data.templates);
                     setFilterTemps(data.templates);
                 }
                 
             })
             .catch(error => {
                 console.error(error);
                 setIsLoading(false);
             })
     }

     const onSearch=(ee)=>{
        setSearch(ee);
        if(ee!=''){
        const _filterSearch = templates?.filter(item => {
              const searchValue = item.title.toLowerCase().includes(ee.toLowerCase())
          
              return searchValue;
            })
        setFilterTemps(_filterSearch);
        }else{
            setFilterTemps(templates);
        }
        
        setSearch(ee);
      }

     const onDelete =async()=>{
        setDeleteBox(false);
        setIsLoading(true);
        try {
            const theurl=`${Constants.apiUrl}/gazette/template/${deleteobj.id}/remove`;
            const resp = await fetch(theurl, {
              method: 'POST',
              body: JSON.stringify({}),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0 ) {
              //on this back
              setAlert(  {open:true,title:'Template', subtitle:"Delete successfully", onOk});
                //filter one off the table
                const pp = filterTemps.filter((c) => c.id !=deleteobj.id) ;
                const pp_ =templates.filter((c) => c.id !=deleteobj.id) ;
                setFilterTemps(pp);
                setTemplates(pp_);
                setDeleteObj({});
            }else {
                setAlert(  {open:true,title:'Placeholder', subtitle:responseData.status, onOk});
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            setAlert(  {open:true,title:'Placeholder', subtitle:"Please clear the content in it and save empty template before you can delete it", onOk});
          }
     }

     const onOk =()=>{
        setAlert({open:false});
    }

     const openDelete=(obj)=>{
       // setIndex(ind);
        setDeleteObj(obj);
        setDeleteBox(true);

     } 

     const onReset=()=>{
        setSearch('');
        setFilterTemps(templates);
     }

     const onNewTemplate=()=>{
       // `/templates/${doc.id}/view`
       navigate(`/templates/${temptype}/create`)
     }

  return (
    <div className='affidavit-table'>

        <div className="body">


            
            <div style={{display:'flex',justifyContent:'space-between' }}>
                <div> <input type="text" placeholder='Search by Title' id='search-title' value={search} onChange={(e)=> onSearch(e.target.value)}/></div>
                <JisButton onClick={onNewTemplate}>New Template</JisButton>
            </div>
            <div className="aff-table">

                <div className="all-div">
                    <h3 style={{flex:1}}> {Constants.TitleCase(temptype) } Templates</h3>
                </div>

               <div className='table'>
                    <div class="section-cases">
                    <span>{Constants.TitleCase(temptype) } Templates</span><span className='total'>{filterTemps?.length}</span>
                    </div>
                  <table className="case-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Document ID</th>
                                <th>Date Created</th>
                                <th>Type</th>
                                <th>Action</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filterTemps?.map((doc, i) => { return (
                                    <tr key={i}>
                                        <td>{doc.title}</td>
                                        <td>{doc.id}</td>
                                        <td>{Constants.formatDate(doc.createdOn) } </td>
                                        <td>{doc.type==1?'DOCUMENT':'AFFIDAVIT'} </td>
                                        <td className='view-affbtn'>
                                            <Link to={`/templates/${doc.id}/view`}><JisButton>View</JisButton> </Link>
                                        </td>
                                        <td className='del-aff' onClick={() => openDelete(doc)}>Delete <DynamicIcon iname="trash-2" /></td>
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table>   
               </div>
              
                
            </div>
            <JisPrompt open={deleteBox} title="Prompt" onOk={onDelete} onCancel={() => setDeleteBox(false)}>
                <DynamicIcon iname="help" /> 
                    <p>Do you want to delete this. {temptype} Template ({deleteobj.title})? Please confirm no other document is using it or used it. Instead Edit it. Yes to Continue to Delete</p>

            </JisPrompt>
          
            {openSuccess && <div className={ "success open" }>
                <div className="success-box">
                    <h2>Successful</h2>
                    <p> Template deleted successfully</p>
                    <button className='red' onClick={()=> setOpenSuccess(false)}>Continue</button>
                </div>
            </div>}

        </div>
        <BackLoader open={isLoading}  />
      
    </div>
  )
}

export default Templates